import FragmentPage from '../core/FragmentPage';

export default class CookiesPage extends FragmentPage {
  constructor(meta) {
    super('cookies', meta);
  }
}
